// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_ofU","cls2":"ActiveState-cls2_SIp ActiveState-cls1_ofU"};